import { all } from 'redux-saga/effects';
import referralInfo from '~/common/redux/sagas/referralInfo';
import previousOrders from './previousOrders';
import userOrders from './userOrders';
import eSign from './eSign';
import driverAccess from './driverAccess';

export default function* rootSagas() {
  yield all([...previousOrders, ...userOrders, ...referralInfo, ...driverAccess, ...eSign]);
}
